$('#num_price, #num_profit').on('focus', function(){
	let price = $('#num_price').val();
	let profit = $('#num_profit').val();
	let payback = $('#num_payback').val();
	let profitability = $('#num_profitability').val();

	if (payback == Math.round(price / profit) || payback == 0)
	{
		$(this).on('input', calcPayback);
	}

	if (profitability == Math.round(profit * 12 * 100 / price) || profitability == 0)
	{
		$(this).on('input', calcProfitability);
	}
});
$('#num_price, #num_profit').on('blur', function(){
	$(this).off('input', calcPayback);
});
$('#num_price, #num_profit').on('blur', function(){
	$(this).off('input', calcProfitability);
});

function calcPayback()
{
	let price = $('#num_price').val();
	let profit = $('#num_profit').val();
	let payback = Math.round(price / profit);
	$('#num_payback').val(payback);
}

function calcProfitability()
{
	let price = $('#num_price').val();
	let profit = $('#num_profit').val();
	let profitability = Math.round(profit * 12 * 100 / price);
	$('#num_profitability').val(profitability);
}

// А хочется вот так )))
/*
$.inutEqual('num_profitability', 
	array('num_profit', 'num_price'), 
	function(profit, price){return Math.round(profit * 12 * 100 / price)}
);
*/